import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleNamePipePipe } from './pipes/role-name-pipe.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [RoleNamePipePipe],
  exports: [RoleNamePipePipe],
})
export class UserModule {}
